module.exports = "https://www.gc-pro.gnp.com.mx/f4c86b6c3839f141976c08696398c04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/facebook.png
// module id = 8108
// module chunks = 0